import pathUrl from "./path"
import instance from './request'


const axios = instance;
const api = {
    // upload data =========================================================================
    getTemplateFile() {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-template-file");
    },
    // Assessment Page==========================================================================
    submitMission(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/submitMission",
        });
    },
    submitMissionNew(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/submitMissionNew",
        });
    },
    getAssessmentResult(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getAssessmentResult/" + id);
    },
    getAssessmentResultUploadInfo(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getAssessmentResultUploadInfo/" + id);
    },
    getAssessmentResultFinish(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getAssessmentResultFinish/" + id);
    },
    getHeatmapData(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getHeatmapData/" + id);
    },

    

    // Data Detail Page==========================================================================
    getSingleProtein(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getSingleProtein/" + id);
    },
    getPairsOfProtein(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getPairsOfProtein/" + id);
    },
    getProteinPair(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getProteinPair/" + id);
    },
    getProteinPairStart(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getProteinPairStart/" + id);
    },

    
    
    
    
    
    
    // Search Form Page==========================================================================

    // blast
    postSequence(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/postSequence",
        });
    },
    // Blast 结果查询
    getSequenceResult(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getSequenceResult/" + id);
    },
    // 二级下拉
    getCategorySearch(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getCategorySearch/" + id);
    },
    // Search 结果查询
    postSearchResult(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/postSearchResult",
        });
    },
    // 关键词更新
    updateGroupKey(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/updateGroupKey",
        });
    },
    


    // Search Result Page==========================================================================

    // SQL 查询
    postSqlInquire(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/postSqlInquire",
        });
    },
    postSqlInquireCompartment(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/postSqlInquireCompartment",
        });
    },





    

    postSpsPlot(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/postSpsPlot",
        });
    },





    // Contact Part=====================================================================
    postContactUs(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/contactus",
        });
    },
    getEmailInputCheck(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getEmailInputCheck/" + id);
    },
    emailInput(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/emailInput",
        });
    },




















}

export default api;